<template>
  <div class="column-index-2">
    <div class="title-mod"  >
      <el-row :gutter="20" v-if="list">
        <el-col :span="16">
          <div class="text">
            {{list.type_name}}
          </div>
        </el-col>
        <el-col :span="8"  >
         <div class="am-text-right">
            <router-link class="more" tag="a" :to="'/list/'+list.type_id"><img src="../../assets/images/more.png" alt=""></router-link>
         </div>
        </el-col>
      </el-row>
       <div class="text" v-if="text">
            {{text}}
          </div>
    </div>

    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      list:{
      },
      text:{
        default:''
      }
    }

  }
</script>

<style lang="scss">
  .column-index-2 {

    .content {
    }

    .title-mod {
      background-image: url(~@/assets/images/titleBg.jpg);
        background-repeat: repeat-x;
         border-radius: 6px;
        height: 28px;
        line-height: 28px;
        padding-right: 6px;
      .text {
        
        color: white;
        font-size: 14px;
        padding: 0 12px;
       
      }

      .more {
      }
    }
  }
</style>